/* eslint-disable */
import axios from 'axios';

import {

    DESIGNER_ORDER,
    CHECK_ORDER,
    INWORK_ORDER,
    READY_ORDER,
    
} from './types'



export default {
    state : {
        _orders : [],
        q : 1,
        files : [], // хранит файлы предзагрузки -  т.е. на этапе добавления дизайнером
        detailsFiles : [], // хранит файлы раскрывающегося списка
        workFiles : [], // хранит все файлы, которые запущены в работу
        fileSpeaks : [], // хранит мессаджи к рабочим файлам
        fileWriteOff : [], // хранит файлы для списания
        sborka : [], //хранит списания всех файлов в работе
        selectedOrders : [], // Хранит номера выделенных заказов
        filter_contragent : null,
        fitler_manager : false,
        filter_executor : null,
        filter_payStatus : null,
        inWorkInfo : null,
        offsetPosition : 0,
        stopUploading : false,
    },
    


    methods : {

        previewTemplate() {
            return {
                width : null,
                height : null,
                comment : null,
                name : null,
                file : null,
                id : null,
            }
        }
    },

    getters : {

        getStanokInfo(state) {
          if (state.inWorkInfo == null) return [];
          return state.inWorkInfo[0] != null ? state.inWorkInfo[0] : [];
        },

        getMaterialInfo(state) {
            if (state.inWorkInfo == null) return [];
            return state.inWorkInfo[1] != null ? state.inWorkInfo[1] : [];
        },

        getFilterPayStatus(state) {
            return state.filter_payStatus;
        },

        getFilterContragent(state) {
            return state.filter_contragent;
        },

        getFilterExecutor(state) {
            return state.filter_executor;
        },

        getAllCost(state) { //считаем полную стоимость изготовления файлов в счете
            var r = 0;
            state.files.forEach((item) => {
                r = r + item.cost*1;
                // console.log(item.cost);
                // console.log(item);
                // console.log(r);
            });
            // console.log(result)
            return r;
        },

        getSelectedOrders(state) { // возвращает отмеченные галочками ордера
            return state.selectedOrders;
        },


        getDetailsFiles: state => id => {
            var list = state.detailsFiles.filter(item => {
                return item.main_id === id;
            }); 
            return list;
        },

        getReadyCount : state => id => {
            
            var list = state.sborka.filter(item => {
                return item.file_id === id;
            }); 
            var c = 0;
            list.forEach(element=>{
                c += element.number;
            });
            return c;
        },
        
        getWriteOffByFileId : state => id => {
            return state.sborka.filter(item => {
                return item.file_id === id;
            });
        },

        getWriteOffFileCount(state) {
            return state.fileWriteOff.length;
        },

        getWriteOffMaterialType(state) {
            if (state.fileWriteOff.length==0) return -1;
            return state.fileWriteOff[0].order.material;
        },

        getWriteOffFiles(state) {
            return state.fileWriteOff;
        },

        isFileInWriteOff: state=>id=> {
            return state.fileWriteOff.find(item => item.order.id == id)!=undefined;
        },
        
        getFileSpeak: state => id => { // отдаем пиздеж по конкретному файлу
            return state.fileSpeaks.filter(item => item.file_id == id);
        },
        

        getWorkFiles(state){
            return state.workFiles;
        },

        getOrderFiles(state){
            return state.files;
        },

        allOrders(state) {
            return state._orders;
        },
    
        designerOrders(state) {
            return state._orders.filter((order)=>{
               let result = (order.stage == DESIGNER_ORDER);
               if (state.filter_contragent != undefined) result = result && (order.contragent==state.filter_contragent);
               if (state.filter_executor != undefined) result = result && (order.executor == state.filter_executor);
               if (state.filter_payStatus != undefined) result = result && (order.pay_status == state.filter_payStatus);
               return result;
            })
        },
        
        checkOrders(state) {
            return state._orders.filter(order=>{
                let result = (order.stage == CHECK_ORDER);
                if (state.filter_contragent != undefined) result = result && (order.contragent==state.filter_contragent);
                if (state.filter_executor != undefined) result = result && (order.executor == state.filter_executor);
                if (state.filter_payStatus != undefined) result = result && (order.pay_status == state.filter_payStatus);
                return result;
            })
        },

        inWorkOrders(state) {
            return state._orders.filter(order=>{
                let result = (order.stage == INWORK_ORDER);
                if (state.filter_contragent != undefined) result = result && (order.contragent==state.filter_contragent);
                if (state.filter_executor != undefined) result = result && (order.executor == state.filter_executor);
                if (state.filter_payStatus != undefined) result = result && (order.pay_status == state.filter_payStatus);
                return result;
            })
        },
        
        readyOrders(state) {
            return state._orders.filter(order=>{
                let result = (order.stage == READY_ORDER);
                if (state.filter_contragent != undefined) result = result && (order.contragent==state.filter_contragent);
                if (state.filter_executor != undefined) result = result && (order.executor == state.filter_executor);
                if (state.filter_payStatus != undefined) result = result && (order.pay_status == state.filter_payStatus);
                return result;
            })
        },

        getOrderById: state => id => {
             return state._orders.find(item => {
                return item.id === id;
            });
        },

        getFileById: state => id => {
            return state.files.find(item => item.id == id);
        },

        getPreviewFiles(state) {          
            return state.files;
        },

    },

    mutations: {
        
        setInWorkInfo(state, data) {
            state.inWorkInfo = data;
        },

        setPayStatusFilter(state, id) {
            state.filter_payStatus = id;
        },

        setExecutorFilter(state, id) {
            state.filter_executor = id;
        },

        setManagerFilter(state, val) {
            state.fitler_manager = val;
        },

        setContragentFilter(state, id) {
            state.filter_contragent = id;
        },

        setCloudLoadingFlag(state, data) {
            const index =  state._orders.findIndex(item => item.id === data.orderId);            
            let q = state._orders[index];
            q.isCloudLoading = data.flag;
            state._orders.splice(index, 1, q);
        },

        clearSelectedOrders(state) {
            state.selectedOrders.splice(0, state.selectedOrders.length);
        },

        selectOrders(state, orders) { // делаем выделение
            if (orders.length == 0) exit; // если новый счет - то список будет пустой (список возвращает функция блокировки)
            state.selectedOrders.splice(0, state.selectedOrders.length); // очищаем массив
            orders.forEach(order => {
                state.selectedOrders.push(order.id); //добавляем номер заказа
            });
        },

        stopWork(state, order){
            //снимаем с работы все файлы данного заказа

            let letsGo = true;
            while (letsGo) {
                const index =  state.workFiles.findIndex(item => item.main_id === order.id);
                if (index>-1) state.workFiles.splice(index, 1);
                else letsGo = false;
            }
            // var newFile = state.workFiles.filter(item => item.main_id != order.id);
            // console.log(newFile);
            // state.workFiles.splice(0, state.workFiles.length, newFile);
            console.log('чистим workFiles');
        },

        refreshOrder(state, data) {
            // ищем номер ордера
            const index =  state._orders.findIndex(item => item.id === data.id);
            if (index>-1) state._orders.splice(index, 1, data);
            else state._orders.push(data);
            // console.log(data);
            
        },

        selectOrder(state, data) {
                   
               const index =  state.selectedOrders.indexOf(data.id);
               if ((index>-1)&&(!data.status)) { //нужно удалить из списка
                    state.selectedOrders.splice(index, 1);
               }
               if ((index==-1)&&(data.status)){ //нужно добавить в список
                    state.selectedOrders.push(data.id);
               }
        },

        closeFile(state, id) { //удаляем файл из списка рабочих
            const index =  state.workFiles.findIndex(item => item.id === id)
            state.workFiles.splice(index, 1);
        },

        addSborka(state, data) {
            
            data.forEach(element => { //добавляем все в массив сборок
                state.sborka.push(element);
            });

            state.fileWriteOff.splice(0, state.fileWriteOff.length); // очищаем список файлов для списания

        },

        clearWriteOffFiles(state) {
            state.fileWriteOff.splice(0, state.fileWriteOff.length); // очищаем массив 
        },
        

        changeCountFileOff(state, data) {
            const index =  state.fileWriteOff.findIndex(item => item.order.id === data.order.id)
            state.fileWriteOff.splice(index, 1, data);
        },

        deleteFileOff(state, id) {
            const index =  state.fileWriteOff.findIndex(item => item.order.id === id)
            state.fileWriteOff.splice(index, 1);
        },

        addFileToWriteOff(state,data) {
            
            //проверяем на дубликат
                var l = state.fileWriteOff.find(item => item.order.id == data.order.id);
                if (l== undefined) { //значит такой элемент уже есть в сборке и выдаем ошибку и ничего не делаем                    
                    state.fileWriteOff.push(data);
                } 

        },
// Добавление едничиных рабочих файлов
// ===========================================================================

        addFileSpeak(state, data) {
            state.fileSpeaks.push(data);
        },

        retrieve_sborka(state, data) {
            state.sborka = data;
        },

        retrieve_work_messages(state, data) {
            state.fileSpeaks = data;
        },

        retrieve_work_files(state, data) { // сохраняем полученные данные в state
            state.workFiles = data;
        },

// Конец добавление едничиных рабочих файлов
// ===============================================================================

        One_retrieve_sborka(state, data) {
            data.forEach(element => {
                state.sborka.push(element);    
            });
        },

        One_retrieve_work_messages(state, data) {
            data.forEach(element => {
                state.fileSpeaks.push(element);
            });
        },

        One_retrieve_work_files(state, data) { // сохраняем полученные данные в state
            data.forEach(element => {
                //ищем дубликаты и заменяем если что.
                let index = state.workFiles.findIndex(item => item.id == element.id);
                if (index == -1) state.workFiles.push(element);     
                else state.workFiles.splice(index, 1, element);
            });
           
        },
// ===============================================================================


        emptyPost(state, id) {
            console.log('empty Posts');
            const index =  state.files.findIndex(item => item.id === id) // находим этот файл
            var elem =  state.files.find(item => item.id === id) // находим этот файл
            let opt = JSON.parse(elem.options);
            delete elem.options.post;
            elem.options = JSON.stringify(opt);
            state.files.splice(index, 1, elem);
        },

        savePostToFile(state, param) {
            
            const index =  state.files.findIndex(item => item.id === param.fileId) // находим этот файл
            let fileOptions = JSON.parse(state.files[index].options);
            fileOptions.post = param.param;
            state.files[index].options = JSON.stringify(fileOptions); // сохраняем настройки

        },

        saveLocalFileParam(state, param) {
            // console.log(param);
            const updateFile = state.files.find(item => item.id == param.id);
            for (let key in updateFile) {  //обновляем полученные поля
                updateFile[key] = param[key];
            }
        },

        deleteFile(state, id){
            const index =  state.files.findIndex(item => item.id === id)
            state.files.splice(index, 1);
        },

        deleteFromBill(state, id) { // удаляем все файлы заказа ID
            let index =  state.files.findIndex(item => item.main_id === id);
            while (index > -1) {
                state.files.splice(index, 1);
                index =  state.files.findIndex(item => item.main_id === id);
            }
        },

        addNewOrder(state, order) {

            state._orders.push(order);
            
        },

        updateOrders(state, data) {
            if (data instanceof Array) 
                data.forEach(order => {
                    const index =  state._orders.findIndex(item => item.id === order.id);
                    if (index>-1) state._orders.splice(index, 1, order);
                    else state._orders.push(order);                   
                });
        },

        updateOrder(state, order) {
            const index =  state._orders.findIndex(item => item.id === order.id);
            if (index>-1) state._orders.splice(index, 1, order);
            else state._orders.push(order);
        },

        deleteOrder(state, id) {
            const index =  state._orders.findIndex(item => item.id === id)
            state._orders.splice(index, 1);
        },

        retrieveOrders(state, orders) {
            //ищем самый маленький id - для того чтобы задать оффсет
            if (orders.length > 0) {
                let q = 0;
                orders.forEach(el => {
                    q = el.id;
                    let index = state._orders.findIndex((item)=>{
                        return item.id == orders.id;
                    })
                    if (index == -1) state._orders.push(el); // если такого элемента нет - добавляем
                    else state._orders.splice(index, 1, el); // если есть - заменяем
                });
                state.offsetPosition = q;
            } else { // если пришел нулевой ответ - завершаем обновление
                state.stopUploading = true;
            }
            // state._orders = orders;
            // this.state.ds.event.emit('test-event', { some : 'data' }); // генерируем событие
        }, 

        addPreviewFile(state, file) {

            var q = {
                width : null,
                height : null,
                comment : null,
                name : null,
                file : null,
                id : null,
            }
            for (let key in file) {  //вставляем полученные поля
                q[key] = file[key];
            }
            state.files.push(q); // вставляем в список

        },

        deleteUploadFile(state, id) {

            const index = state.files.findIndex(item => item.id === id)
            state.files.splice(index, 1);
            
        },

        clearAllUploadFile(state) {
            state.files.splice(0, state.files.length);
        },

        saveFileParam(state, fileParam) {

            var value = state.files.find(item => item.id === fileParam.id); //находим старые значения
            // меняем только избранные значения
            for (let key in fileParam) {
                value[key] = fileParam[key];
            }
            const index = state.files.findIndex(item => item.id === fileParam.id);
            state.files.splice(index, 1, fileParam);

        },

        getFiles(state, files) {
            state.files = files;
        },

        getDetailsFiles(state, files) { // тут нужно не заменять а добавлять
            // console.log(files);
            files.forEach(element => {
                const index = state.detailsFiles.findIndex(item => item.id === element.id);                
                if (index > -1) state.detailsFiles.splice(index, 1, element);// значит заменяем
                else  state.detailsFiles.push(element) // значит добавляем
            });
        },

    },

    actions : {

        updateFileParam(context, item) {
            return new Promise((resolve, reject)=> {
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.rootState.token;
                axios.post('/updateFileParam', item) // обновляем параметры файла в безликом заказе
                .then(response => {

                    // context.rootState.ds.event.emit(context.rootGetters.getPrefix, {'event':'closeFile', 'content' : fileId});//генерируем событие deepstream - закрыть файл везьде

                    // if (response.data != -1) { // значит заказ выполнен полностью - обновляем ордера
                        // context.rootState.ds.event.emit(context.rootGetters.getPrefix, {'event':'updateOrder', 'content' : response.data});
                    // }
                    console.log(response.data);
                    resolve(response.data);

                })
                .catch(error => {
                    reject(error);
                });

            });
        },

        closeFile(context, fileId){  // Закрываем файл

            return new Promise((resolve, reject)=> {
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.rootState.token;
                axios.post('/closeFile', {fileId}) // говорим серверу какой файл закрыть
                .then(response => {

                    context.rootState.ds.event.emit(context.rootGetters.getPrefix, {'event':'closeFile', 'content' : fileId});//генерируем событие deepstream - закрыть файл везьде

                    if (response.data != -1) { // значит заказ выполнен полностью - обновляем ордера
                        context.rootState.ds.event.emit(context.rootGetters.getPrefix, {'event':'updateOrder', 'content' : response.data});
                    }

                    resolve(response);

                })
                .catch(error => {
                    reject(error);
                });

            });

        },

        saveWriteOffFiles({ state, commit, rootState, rootGetters }, writeOffData) { //сохраняем на сервер файлы списания

            var data = {
                writeOffData : writeOffData,
                fileWriteOff : state.fileWriteOff,
            }
            return new Promise((resolve, reject)=> {
                // axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.token;
                
                axios.post('/addSborka', data) // отдаем массив на сервер
                .then(response => {
                    rootState.ds.event.emit(rootGetters.getPrefix, {'event':'addSborka', 'content' : response.data});
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });

            });

        },

        saveMessage(context, data) { //комментарии к файлу
            
            return new Promise((resolve, reject)=> {

                axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.rootState.token;
                var q = data;
                q.when = new Date();
                q.offset = q.when.getTimezoneOffset();
                axios.post('/saveMessage', data)
                .then(response => {
                    context.rootState.ds.event.emit(context.rootGetters.getPrefix, {'event':'addFileSpeak', 'content' : response.data});
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });

            });
        },

        retrieve_work_files(context) {  //получаем все файлы, которые запущены в работу

            axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.rootState.token;

            return new Promise((resolve, reject)=> {
                axios.get('/getWorkFiles')
                .then(response => {
                    context.commit('retrieve_work_files', response.data[0]);
                    context.commit('retrieve_work_messages', response.data[1]);
                    context.commit('retrieve_sborka', response.data[2]);
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });

            });
        },

        retrieveWorkFile(context, order) {
        
            return new Promise((resolve, reject)=> {
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.rootState.token;

                axios.get('/getWorkFile/'+order.id, order.id)
                .then(response => {
                    context.commit('One_retrieve_work_files', response.data[0]);
                    context.commit('One_retrieve_work_messages', response.data[1]);
                    context.commit('One_retrieve_sborka', response.data[2]);
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });

            });      
        },

        retrieveBillFiles({dispatch, commit, state, rootState}) { // получаем файлы для счета. Номера заказов берем из selectedOrders

            return new Promise((resolve, reject)=> {

                axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.token;

                axios.post('/getBillFiles', {orders : state.selectedOrders})
                .then(response => {
                    commit('getFiles', response.data['files']);
                    commit('setBill', response.data['bill']);
                    resolve(response);
                })
                .catch(error => {
                    let t = 2500;
                    if (error.response.headers["retry-after"] != undefined) t = error.response.headers["retry-after"];
                    setTimeout(()=>{ //повторная загрузка через секунду
                       dispatch('getFiles')
                    }, t); // через секунду повторно вызываем получение ордеров
                    reject(error);
                });

            });      

        },

        setToWork({state, rootState, rootGetters}, index) { // действие на изменение stage = делаем его +1

            return new Promise((resolve, reject)=> {

                //нужно получить нужный ордер клонировать (чтобы раньше времени не было изменений) клон сохранить на сервере.. и потом уже коммитить
                const updateOrder = state._orders.find(item => item.id == index);
                let newOrder = Object.assign({}, updateOrder);
                newOrder.stage++;  

                axios.post('/orders/' + index, newOrder)
                .then(response => {
                    rootState.ds.event.emit(rootGetters.getPrefix, {'event':'updateOrder', 'content' : newOrder});
                    rootState.ds.event.emit(rootGetters.getPrefix+'_dispatch', {'event':'retrieveWorkFile', 'content' : newOrder});
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
            })
        },

        executorReady({state, rootState, rootGetters}, index) { // готовность заказа у стороннего исполнителя

            return new Promise((resolve, reject)=> {
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.token;
                //нужно получить нужный ордер, исправить и послать его на сохранение
                
                const updateOrder = state._orders.find(item => item.id == index);

                let newOrder = Object.assign({}, updateOrder);
                newOrder.stage++;
                newOrder.ready = 1;
                newOrder.wh_ready = new Date();

                axios.post('/orders/' + index, newOrder)
                .then(response => {
                    rootState.ds.event.emit(rootGetters.getPrefix, {'event':'updateOrder', 'content' : newOrder});
                    rootState.ds.event.emit(rootGetters.getPrefix, {'event':'stopWork', 'content' : newOrder});
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
            })
        },
        

        stopWork({state, rootState, rootGetters}, index) { // действие на изменение stage = делаем его -1

            return new Promise((resolve, reject)=> {
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.token;
                //нужно получить нужный ордер, исправить и послать его на сохранение
                const updateOrder = state._orders.find(item => item.id == index);
                let newOrder = Object.assign({}, updateOrder);
                newOrder.stage--;

                axios.post('/orders/' + index, newOrder)
                .then(response => {

                    rootState.ds.event.emit(rootGetters.getPrefix, {'event':'updateOrder', 'content' : newOrder});
                    rootState.ds.event.emit(rootGetters.getPrefix, {'event':'stopWork', 'content' : newOrder});
                    // rootState.ds.event.emit('updateOrder', newOrder); // генерим апдейт для заказа
                    // rootState.ds.event.emit('stopWork', newOrder); //снимаем с работы файлы в печати
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
            })
        },

        deleteFileFromOrder(context, index) {

            return new Promise((resolve, reject)=> {
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.rootState.token;
                axios.delete('/files/' + index, {
                    id : index,
                })
                .then(response => {
                    context.commit('deleteFile', index);
                    resolve(true);
                })
                .catch(error => {
                    reject(error);
                });
            })
        },

        deleteOrder({context, rootState, rootGetters }, order) {

            axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.token;

            axios.delete('/orders/' + order.id, {
                id : order.id,
            })
            .then(response => {
                    rootState.ds.event.emit(rootGetters.getPrefix, {'event':'deleteOrder', 'content' : order.id});
                    // context.rootState.ds.event.emit('deleteOrder', order.id);
            })
            .catch(error => {
                 console.log(error);
            });    

        },

        retrieveOrders({dispatch, commit, rootState, state}) {

            return new Promise((resolve, reject)=> {
                
                if (state.stopUploading) {
                    console.log('стоп');
                    reject(1); 
                } // если загружать больше не нужно - прекращаем

                axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.token;

                axios.post('/orders', {offset : state.offsetPosition})
                .then(response => {
                        commit('retrieveOrders', response.data)                 
                        resolve(true);
                })
                .catch(error => {
                        if ((error.response.status == 401)||(error.response.status == 500)) {
                            console.log(error);
                        } else {
                            console.log(error);
                            let t = error.response.status == 429 ? 15000 : 1500;
                            if (error.response.headers["retry-after"] != undefined) t = error.response.headers["retry-after"];
                            setTimeout(()=>{ //повторная загрузка через секунду
                            dispatch('retrieveOrders')
                            }, t); // через секунду повторно вызываем получение ордеров
                        }
                    reject(error.response.status);
                });
            });

        },

        getFiles(context, index) {
            
            return new Promise((resolve, reject)=> {
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.rootState.token;
                axios.get('/files/' + index, {
                    id : index,
                })
                .then(response => {
                    context.commit('getFiles', response.data);
                    resolve(true);
                })
                .catch(error => {
                    reject(error);
                });
            })
        },

        getDetailsFiles(context, index) {
            return new Promise((resolve, reject)=> {
                // axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.rootState.token;
                axios.get('/files/' + index, {
                    id : index,
                })
                .then(response => {
                    context.commit('getDetailsFiles', response.data);
                    resolve(response.data); // еще и отдаем их запросившему
                })
                .catch(error => {
                    reject(error);
                });
            })
        },

        getDetailsSelectedFiles({state, commit, dispatch, rootState, rootGetters}) { // получаем все файлы выделенных заказов
            
            return new Promise((resolve, reject)=> {
                
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.token;
                let orderList = rootGetters.getSelectedOrders;
                axios.post('/selectedFiles', {orderList : orderList})
                .then(response => {                                        
                    resolve(response.data); // возвращаем сразу данные... а не сохраняем в базу
                })
                .catch(error => {
                    reject(error);
                });
            });

        },

        updateOrder({state, dispatch, rootState, rootGetters}, data) {

            var order = data; 
            
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.token;
            
            return new Promise((resolve, reject) => {
                    // console.log(order);
                    order.previews = JSON.stringify(state.files);
                    axios.post('/orders/' + order.id, order)
                    .then(response => {

                        // старт загрузки файлов
                        dispatch('startUploadFiles', response.data.id); // загружаем файлы в папку id
                        rootState.ds.event.emit(rootGetters.getPrefix, {'event':'updateOrder', 'content' : response.data});
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error)
                    });
            });
        },

        lockOrder({rootState, rootGetters}, orderId) { // блокируем ордер для остальных пользователей
            
            return new Promise((resolve, reject) => {
                
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.token;
                
                axios.post('/orders/lock/' + orderId, {id:orderId})
                .then(response => {
                    rootState.ds.event.emit(rootGetters.getPrefix, {'event':'updateOrder', 'content' : response.data});
                    resolve(response);
                })
                .catch(error => {
                    reject(error)
                });
            });
        },

        lockOrders(context, orderList) { // блокирует записи. Номера передаем массивом в параметрах
            return new Promise((resolve, reject) => {
                
                // axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.rootState.token;
                axios.post('/lockOrders', {orders : orderList})
                .then(response => {
                    context.rootState.ds.event.emit(context.rootGetters.getPrefix,{'event':'updateOrders', 'content' : response.data});
                    resolve(response);
                })
                .catch(error => {
                    reject(error)
                });
            });
        },
        
        lockBillLinkOrders({commit, rootState, rootGetters}, order) {
            // заблокировать заказы, связанные с заказом orderNum

            return new Promise((resolve, reject) => {
                
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.token;
                if (order.bill_out == null) resolve();
                axios.post('/lockBillOrders', {billNum : order.bill_out}) // передадим еще дополнительно ИД ордера
                .then(response => {
                    commit('selectOrders', response.data); // изменяем список выделенных заказов в соответствии с заблокированными заказами
                    rootState.ds.event.emit(rootGetters.getPrefix,{'event':'updateOrders', 'content' : response.data});
                    resolve(response);
                })
                .catch(error => {
                    reject(error)
                });
            });

        },

        unlockOrders(context, orderList) { // блокирует записи. Номера передаем массивом в параметрах
            return new Promise((resolve, reject) => {
                
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.rootState.token;
                axios.post('/unlockOrders', {orders : orderList})
                .then(response => {
                    // context.rootState.ds.event.emit('updateOrders', response.data);
                    context.rootState.ds.event.emit(context.rootGetters.getPrefix,{'event':'updateOrders', 'content' : response.data});
                    resolve(response);
                })
                .catch(error => {
                    reject(error)
                });
            });

        },

        unlockOrder(context, orderId) { // разблокируем ордер для остальных пользователей
            
            return new Promise((resolve, reject) => {
                
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.rootState.token;
                
                axios.post('/orders/unlock/' + orderId, {id:orderId})
                .then(response => {
                    // context.rootState.dsevent.emit('updateOrder', response.data);
                    // context.rootState.ds.emit('updateOrder', response.data);
                    context.rootState.ds.event.emit(context.rootGetters.getPrefix, {'event':'updateOrder', 'content' : response.data});
                    resolve(response);
                })
                .catch(error => {
                    reject(error)
                });
            });
        },

        getInWorkInfo(context) { // запрашиваем запущенный объем работы (но не списанный)

            return new Promise((resolve, reject) => {
                
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.rootState.token;
                axios.get('/getInWorkInfo')
                .then(response => {
                    context.commit('setInWorkInfo', response.data);
                    resolve(response);
                })
                .catch(error => {
                    reject(error)
                });
            });
        },


    }

}